import { Observable } from 'rxjs';
import { GetPlaceResult } from '@theme/google-map/models/address';
import { Location } from '@core/models/location';

export function geocodingAddress(formattedAddress: string): Observable<Location> {

  return new Observable(observer => {
    new google.maps.Geocoder().geocode({ address: formattedAddress }, (results, status) => {
      let gMapLocation: Location = null;
      if (status === google.maps.GeocoderStatus.OK &&
        (results && results[0].geometry.location_type === google.maps.GeocoderLocationType.ROOFTOP ||
          results[0].geometry.location_type === google.maps.GeocoderLocationType.RANGE_INTERPOLATED)) {
        const address = GetPlaceResult(results[0]);
        gMapLocation = Location.getGmapAddress(address);
      } else {
        gMapLocation = new Location();
      }
      observer.next(gMapLocation);
    });
  });
}

